@if (specLot()) {
  <!-- Lot number + type badge -->
  <div class="flex items-center gap-4 mb-4">
    <span class="font-medium text-body-lg-500 text-primary-700 font-title">{{ specLot()?.lotNo || '—' }}</span>
    <p-badge [value]="specLot()?.lotTypeName?.toUpperCase() || 'LOT'" severity="contrast" badgeSize="small" />
  </div>

  <!-- 7-field data grid (same fields as sales) -->
  <div class="grid grid-cols-2 sm:!grid-cols-3 lg:!grid-cols-5 gap-x-4 gap-y-5">
    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Project</span>
      <span class="text-body-500 text-slate-700">{{ specLot()?.projectCode || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Status</span>
      <span class="text-body-500 text-slate-700">{{ specLot()?.statusName || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">City</span>
      <span class="text-body-500 text-slate-700">{{ specLot()?.address?.cityName || '—' }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Premium Amount</span>
      <span class="text-body-500 text-slate-700">{{ fmt(specLot()?.lotPremiumAmount) }}</span>
    </div>

    <!-- <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Unit Price</span>
      <span class="text-body-500 text-slate-700">{{ fmt(specLot()?.lotUnitPrice) }}</span>
    </div> -->

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Model</span>
      <span class="text-body-500 text-slate-700">{{ modelLabel }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Elevation</span>
      <span class="text-body-500 text-slate-700">{{ elevationLabel }}</span>
    </div>

    <div class="flex flex-col gap-0.5">
      <span class="text-body-xs text-slate-700 uppercase tracking-wider">Swing</span>
      <span class="text-body-500 text-slate-700">{{ specLot()?.swing || '—' }}</span>
    </div>
  </div>
} @else {
  <p class="text-body-sm text-slate-400 text-center py-6">Lot information not available.</p>
}
